module.exports = __webpack_public_path__ + "static/media/temp-persona-9.7682b2ef.jpg";